export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_07-de58a0731b0d76922b534d100e49845a.jpg";